import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d5476cd"
import script from "./index.vue?vue&type=script&lang=tsx"
export * from "./index.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports